import React, { useEffect, useRef } from 'react';

function formatDateInputValue(dateLike) {
  const date = new Date(dateLike);
  if (Number.isNaN(date.getTime())) return '';
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function parseCompleteDateInputValue(value) {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value || '');
  if (!match) return null;

  const [, yearText, monthText, dayText] = match;
  const year = Number(yearText);
  const month = Number(monthText);
  const day = Number(dayText);

  // Native date inputs zero-pad a year while it is being typed. Waiting for a
  // normal four-digit year prevents "2" becoming 0002 and moving the calendar
  // to 1902 before the user can finish typing 2026.
  if (year < 1000 || month < 1 || month > 12 || day < 1 || day > 31) return null;

  const parsed = new Date(year, month - 1, day);
  if (
    parsed.getFullYear() !== year
    || parsed.getMonth() !== month - 1
    || parsed.getDate() !== day
  ) return null;

  return parsed;
}

export default function DateJumpInput({ id = 'calendar-date-jump', date, onDateChange }) {
  const inputRef = useRef(null);
  const formattedDate = formatDateInputValue(date);

  useEffect(() => {
    const input = inputRef.current;
    if (!input || input === document.activeElement) return;
    input.value = formattedDate;
  }, [formattedDate]);

  const resetIncompleteValue = () => {
    const input = inputRef.current;
    if (input && !parseCompleteDateInputValue(input.value)) {
      input.value = formattedDate;
    }
  };

  return (
    <input
      ref={inputRef}
      id={id}
      type="date"
      defaultValue={formattedDate}
      onChange={(event) => {
        const nextDate = parseCompleteDateInputValue(event.target.value);
        if (nextDate) onDateChange(nextDate);
      }}
      onBlur={resetIncompleteValue}
      style={{
        border: '1px solid #cbd5e1',
        borderRadius: 8,
        padding: '0.42rem 0.6rem',
        fontSize: 14,
        lineHeight: 1.2,
        color: '#0f172a',
        background: '#fff',
        maxWidth: '100%',
        boxSizing: 'border-box',
      }}
    />
  );
}

